
import React from 'react';
import { cn } from '@/lib/utils';

interface ProgressBarProps {
  current: number;
  total: number;
  correctAnswers: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ current, total, correctAnswers }) => {
  const progress = (current / total) * 100;
  const accuracy = total > 0 ? (correctAnswers / current) * 100 : 0;
  
  return (
    <div className="w-full max-w-2xl mx-auto mb-6">
      <div className="flex justify-between items-center mb-2">
        <div className="text-sm font-medium">
          Question {current} of {total}
        </div>
        <div className="text-sm font-medium">
          Score: {correctAnswers}/{current > 0 ? current : 0} ({current > 0 ? Math.round(accuracy) : 0}%)
        </div>
      </div>
      <div className="h-2 w-full bg-muted rounded-full overflow-hidden">
        <div 
          className={cn(
            "h-full transition-all duration-500 ease-out",
            accuracy >= 70 ? "bg-teal-500" : 
            accuracy >= 50 ? "bg-amber-500" : "bg-destructive"
          )}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
